import { Chip, ProfileImage } from "@twioku/common_components";
import { Answerer } from "../../../api/generated";
import { useWellnessChecks } from "../useWellnessChecks";
import { Link } from "react-router-dom";
import ChevronsRight from "../../../assets/chevrons_right.svg";

type Props = {
    answerer: Answerer;
};

export const WellnessChecksAnswererItem = (props: Props) => {
    const { answerer } = props;
    const { hasNewWellnessCheck } = useWellnessChecks(answerer.answererId);
    return (
        <Link
            to={"/wellness-checks/answerer/" + answerer.answererId}
            className="mx-5 flex justify-between py-3"
        >
            <div className="flex">
                <ProfileImage src={answerer.profileImagePath} size="small" />
                <span className="my-auto block px-3">{answerer.name}</span>
            </div>
            <div className="flex">
                {!answerer.isPrivacyAndUsageTermsAgreed && (
                    <div className="my-auto flex h-6 w-auto justify-center rounded-full bg-yellow-100 px-2">
                        <div className="my-auto w-max text-sm text-yellow-500">
                            ※開始前
                        </div>
                    </div>
                )}
                {hasNewWellnessCheck && (
                    <div className="my-auto h-8">
                        <Chip color="success">新着あり</Chip>
                    </div>
                )}
                <img className="w-7" src={ChevronsRight} alt="詳細へ進む" />
            </div>
        </Link>
    );
};
